import type { TpaMessageHistoryApi, TpaMessageRecord, AddTpaMessageRecordData } from './types'

type HistoryApiParts = {
	tpaMessageHistory: Array<TpaMessageRecord>
	clearHistory: () => void
	api: TpaMessageHistoryApi
}

export const createTpaMessageHistoryApi = (): HistoryApiParts => {
	const isResponseMessage = (message: TpaMessageRecord['message']) => message.intent === 'TPA_RESPONSE'

	let callIdHistoryIndex: { [callId: string]: number } = {}
	const tpaMessageHistory: Array<TpaMessageRecord> = []
	return {
		tpaMessageHistory,
		clearHistory() {
			callIdHistoryIndex = {}
			while (tpaMessageHistory.length) {
				tpaMessageHistory.pop()
			}
		},
		api: {
			addMessage({ contextId, compId, message }: AddTpaMessageRecordData) {
				const globalMessageId = `${compId}_${message.callId}`
				const isResponse = isResponseMessage(message)
				const record: TpaMessageRecord = {
					compId,
					message,
					type: message.type ?? '',
					metaData: {
						globalMessageId,
						contextId,
						timestamp: Date.now(),
					},
				}
				if (isResponse) {
					const requestIndex = callIdHistoryIndex[globalMessageId]
					tpaMessageHistory[requestIndex].metaData.responseTime =
						record.metaData.timestamp - tpaMessageHistory[requestIndex].metaData.timestamp
					tpaMessageHistory[requestIndex].response = record.message
				} else {
					callIdHistoryIndex[globalMessageId] = tpaMessageHistory.push(record) - 1
				}
			},
		},
	}
}
